import TimecardView from './TimecardView';

export default TimecardView;
